import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ArchitectsOfYourFinancialFuture() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const serviceImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577498/img/elyon_landscaping_mastery.png",
    alt: "Pristine landscape maintenance and lawn care by Elyon professionals"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577498/img/elyon_luxury_painting_services.png",
    alt: "Masterful interior and exterior painting with premium finishes"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577498/img/elyon_advanced_pressure_washing.png",
    alt: "High-performance power washing for driveways and building exteriors"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577498/img/elyon_meticulous_janitorial_cleaning.png",
    alt: "Deep cleaning and janitorial services for commercial and residential spaces"
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex(prev => (prev + 1) % serviceImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [serviceImages.length]);
  return <section data-section-id="25948" id="premium-property-care-hero" className="relative w-full min-h-[90vh] flex items-center bg-background text-foreground overflow-hidden py-20 lg:py-0">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577498/img/noise_texture.png')] mix-blend-overlay"></div>
      
      {}
      <div className="absolute top-1/2 left-1/4 -translate-x-1/2 -translate-y-1/2 text-[40rem] font-sans font-black text-primary/[0.03] select-none pointer-events-none z-0">
        E
      </div>

      <div className="container mx-auto px-6 md:px-12 h-full relative z-10">
        <div className="flex flex-col lg:flex-row items-center h-full gap-16 lg:gap-24">
          
          {}
          <div ref={contentRef} className={`w-full lg:w-3/5 fl ex flex-col justify-center space-y-10 transition-all duration-1000 [transition-timing-function:cubic-bezier(0.34,1.56,0.64,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <span className="inline-block font-sans text-lg md:text-xl text-primary font-semibold tracking-wider border-b-2 border-border pb-2">
                Premium Facility Maintenance
              </span>
              
              <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-sans font-black tracking-tighter leading-[1.05]">
                <span className="bg-gradient-to-br from-foreground via-foreground/90 to-foreground/70 bg-clip-text text-transparent">
                  Elevating Property <br className="hidden lg:block" />
                  Care to an <span className="text-primary">Art</span> Form
                </span>
              </h1>
              
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl font-sans font-medium leading-relaxed">
                Elyon Maintenance Inc. is your one-stop shop for residential and commercial excellence, delivering top-tier craftsmanship in landscaping, painting, and professional cleaning.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 pt-2">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 border-none rounded-lg px-10 h-14 text-base font-bold tracking-wide shadow-xl shadow-primary/20 transition-transform hover:-translate-y-0.5">
                <Link to="https://elyonmaintenance.com/#get-your-maintenance-quote">
                  Get a Free Quote
                </Link>
              </Button>
              
              <Button asChild variant="ghost" size="lg" className="text-primary hover:text-primary hover:bg-primary/5 border-border border rounded-lg px-8 h-14 text-base font-bold group relative overflow-hidden">
                <Link to="/ShowcasePage">
                  <span className="relative z-10">View Showcase</span>
                  <span className="absolute bottom-3 left-8 right-8 h-px bg-primary transform scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100"></span>
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="w-full lg:w-2/5 h-[500px] lg:h-[750px] relative flex items-center justify-center lg:justify-end">
             <div className={`relative w-full max-w-md lg:max-w-full h-full overflow-hidden shadow-2xl border border-border bg-card/30 backdrop-blur-md ${currentImageIndex === 3 ? "rounded-lg" : "rounded-full"}`}>
                {serviceImages.map((image, i) => <img key={image.src} data-index={i} src={image.src} alt={image.alt} className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 ease-in-out ${i === currentImageIndex ? "opacity-100 scale-100" : "opacity-0 scale-110"}`} />)}
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/10 via-transparent to-transparent pointer-events-none"></div>
             </div>
          </div>

        </div>
      </div>
    </section>;
}